
import { Component, OnInit,Input} from '@angular/core';
import { Mode } from '../../utility/enums/enums';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'message',
    templateUrl: './message.component.html',
   
    
  })
  export class MessageComponent implements  OnInit {
   
    
    @Input() mode: Mode = Mode.Success;
    @Input() showH4: boolean = true;
    @Input() message: string;
    @Input() enableRichText: boolean = false;

    enumMode = Mode;
    
    ngOnInit(): void {
    }

    

  }